import { render } from "./AdminDiscount.vue?vue&type=template&id=3907adee&scoped=true"
import script from "./AdminDiscount.vue?vue&type=script&lang=js"
export * from "./AdminDiscount.vue?vue&type=script&lang=js"

import "./AdminDiscount.vue?vue&type=style&index=0&id=3907adee&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3907adee"]])

export default __exports__